export default __webpack_public_path__ + "images/apple_hover.d0bf89bb.svg";